import React from 'react';
import './NotFound.css';

function NotFound() {
  return (
    <section className="notfound-section">
      <div className="notfound-section-container">
        <h2 className="notfound-title">This page does not exist</h2>
      </div>
    </section>
  )
}

export default NotFound;
